import styled from 'styled-components';
import { TextField } from '@material-ui/core';

export const StyledAgencyField = styled(TextField)`
  width: ${(props) => props.width};
  background-color: rgba(51, 51, 51, 0.05);
  margin: ${(props) => props.margin || '0'};

  .Mui-focused {
    margin-left: 0;
  }

  .MuiInputLabel-root,
  .MuiInputBase-root {
    background-color: transparent;
  }

  .MuiFilledInput-input {
    padding: 20px 12px 10px;
  }

  .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl,
  .PrivateNotchedOutline-root-19 {
    padding: 0;
  }
  .PrivateNotchedOutline-root-20 {
    padding: 0 !important;
  }

  .MuiInputLabel-filled {
    transform: translate(12px, 25px) scale(1);
  }

  .MuiInputLabel-filled.MuiInputLabel-shrink {
    transform: translate(12px, 2px) scale(0.75);
  }
`;

export default StyledAgencyField;
